import React, {ReactElement} from "react";
import {
  BaseSettingsFooterTabFragment,
  BaseSettingsFooterTabFragmentProps,
  BaseSettingsFooterTabFragmentState
} from "shared/BaseSettingsFooterTabFragment";
import {Box, Card} from "@mui/material";
import {AppPrefs} from "../app_prefs";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {THEME_BG} from "../App";

export type SettingsFragmentProps = BaseSettingsFooterTabFragmentProps & {}

type SettingsFragmentState = BaseSettingsFooterTabFragmentState & {}

export class SettingsFragment extends BaseSettingsFooterTabFragment<SettingsFragmentProps, SettingsFragmentState> {

  private readonly appPrefs = AppPrefs.getInstance();

  renderContent(): React.ReactElement {
    return <StyledBoxColumn style={{
      backgroundImage: THEME_BG,
      flexGrow: 1
    }}>
      {super.renderContent()}
    </StyledBoxColumn>;
  }

  protected renderSettingsContent(): ReactElement {
    return <>
      <Card>
        <Box style={{display: "flex", flexDirection: "column"}}>
          {this.renderToggle("Auto Send Chat", this.appPrefs.getAutosendChat(), (value: boolean) => {
            this.appPrefs.setAutosendChat(value);
            this.forceUpdate();
          })}
          {this.renderToggle("Auto Switch Call Turns", this.appPrefs.getAutoswitchCallTurn(), (value: boolean) => {
            this.appPrefs.setAutoswitchCallTurn(value);
            this.forceUpdate();
          })}
        </Box>
      </Card>
    </>;
  }
}
